import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { daysToRelease } from './studioRules';

/**
 * The Studio song list order (Q9, b1 sort): upcoming songs first, the nearest release first; then
 * the released songs, the newest first; then the songs with no date.
 */
export function sortSongsForStudio(items: CatalogItem[], now: Date): CatalogItem[] {
  const rank = (item: CatalogItem): [number, number] => {
    const days = daysToRelease(item.releaseDate, now);
    if (days === null) {
      return [2, 0];
    }
    return days > 0 ? [0, days] : [1, -days];
  };
  return [...items].sort((a, b) => {
    const [groupA, keyA] = rank(a);
    const [groupB, keyB] = rank(b);
    return groupA === groupB ? keyA - keyB : groupA - groupB;
  });
}
